import * as React from 'react';
import { localization, LocHelperInstance } from '../../../shared/localization/localization';
import { EmailInput } from 'src/App/shared/components/email-input.component';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { UserEmailStorageKey } from 'src/App/shared/constants';
import { withAppContext, IAppContext } from 'src/App/shared/app-context';
import { TryGetValue, TrySetValue } from "../../../shared/local-storage";
import { Document, Page, pdfjs } from "react-pdf";
import { pdfjsWorker } from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export interface IProofreadingDialogProps {
    appContext: IAppContext;
    onClose(): void;
    onSendConfirm(email: string, saveMotive: boolean): void;
    previewImg: string;
}

export interface IProofreadingDialogState {
    email: string;
    emailIsValid: boolean;
    showValidationError: boolean;
    visualizationProcessDescription: string;
    saveMotive: boolean;
}

class ProofreadingDialog extends React.PureComponent<IProofreadingDialogProps, IProofreadingDialogState> {

    constructor(props: IProofreadingDialogProps) {
        super(props);

        let email = '';
        const emailValue = TryGetValue(UserEmailStorageKey);
        if(emailValue.hasValue) {
            email = emailValue.value as string;
        }

        this.state = {
            email,
            emailIsValid: false,
            showValidationError: false,
            visualizationProcessDescription: '',
            saveMotive: true
        };
    }

    public async componentDidMount() {
        const apiKey = this.props.appContext.getApiKey() as string;
        const visualizationProcessDescription = await LocHelperInstance.getVisualizationProcessDescription(apiKey);
        this.setState({visualizationProcessDescription});
    }

    private handleSendConfirm() {
        if(!this.state.emailIsValid){
            return;
        }

        TrySetValue(UserEmailStorageKey, this.state.email);
        this.props.onSendConfirm(this.state.email, this.state.saveMotive)
    }

    private toggleCheckboxChange() {
        this.setState({saveMotive: !this.state.saveMotive});
    }

    public render() {
        return (
            <div className="proofreading-dialog-root">
                <div className="title primary-style">
                    <h3><Markdown text={localization.editorLoc.logoEditorContent.proofreading.title} /></h3>
                    <div className="dialog-close-container">
                        <button onClick={() => this.props.onClose()}>
                            <FontAwesomeIcon icon={faTimes} color={'black'} />
                        </button>
                    </div>
                </div>
                <div className="content-container">
                    <div className="main-content">
                        <div className="preview-container">
                            {/*<img src={this.props.previewImg} className="preview" />*/}
                            <div className="preview-container-inner">
                                <Document
                                    file={this.props.previewImg}
                                    onLoadSuccess={(arg:any) => console.log(arg)}
                                    onLoadError={(arg:any) => console.log(arg)}
                                    onSourceError={(arg:any) => console.log(arg)}>
                                    <Page pageNumber={1} />
                                </Document>
                            </div>
                        </div>
                        <div className="info-container">
                            <div className="actions">
                                <div className="email-info">
                                    <span className="email-label"><Markdown text={localization.editorLoc.logoEditorContent.proofreading.emailLabel} /></span>
                                    {this.state.showValidationError && !this.state.emailIsValid &&
                                        <span className="validation-message"><Markdown text={localization.editorLoc.logoEditorContent.proofreading.emailErrorMsg} /></span>
                                    }
                                </div>
                                <EmailInput
                                    email={this.state.email}
                                    onEmailChanged={(email, isValid, showError) => {
                                        this.setState({
                                            email,
                                            emailIsValid: isValid,
                                            showValidationError: showError
                                        });
                                    }}
                                    placeholder={localization.editorLoc.logoEditorContent.proofreading.emailPlaceholder}
                                    disabled={false}
                                />
                                <label className="save-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={this.state.saveMotive}
                                        onChange={() => this.toggleCheckboxChange()}
                                    />
                                    <Markdown text={localization.editorLoc.logoEditorContent.proofreading.saveMotiveCheckbox} />
                                </label>
                                <button
                                    className="send-final"
                                    disabled={!this.state.emailIsValid}
                                    onClick={() => this.handleSendConfirm()}>
                                    <Markdown text={localization.editorLoc.logoEditorContent.proofreading.sendConfirm} />
                                </button>
                            </div>
                            {/* <Markdown text={localization.editorLoc.logoEditorContent.proofreading.infoText} /> */}
                            <div dangerouslySetInnerHTML={{__html: this.state.visualizationProcessDescription}}/>
                        </div>
                    </div>
                    <div className="header-warning">
                        <div className="line-1"><Markdown text={localization.editorLoc.logoEditorContent.proofreading.colorWarnLine1} /></div>
                    </div>
                </div>
            </div>
        );
    }
}

export const Proofreading = withAppContext(ProofreadingDialog)



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-dialogs/proofreading.dialog.tsx